/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */

import { DateTime } from 'luxon';
import userState from '@/store/user';
import { FieldChildrenProp } from '@/services/hexabase/types';

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace optionalForm {
  export const MATTEMPOPTIN = [
    // 登録日
  ];
}
export const materialTemplateOptionalForm = optionalForm.MATTEMPOPTIN;

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace headerForm {
  export const materialTemplateRegister: Array<FieldChildrenProp> = [
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      search: false,
      show_list: false,
      as_title: false,
      status: false,
      fieldIndex: 1,
      title_order: 1,
      full_text: false,
      unique: false,
      min_value: '',
      max_value: '',
      // ****** //
      field_id: 'サービス種別',
      name: 'サービス種別',
      display_id: 'サービス種別',
      dataType: 'text',
      component: 'InputArea',
      props: {
        labelName: 'サービス種別',
        labelText: 'サービス種別',
        name: 'サービス種別',
        isReadonly: true,
        isDisabled: true,
        rules: '',
        value: ''
      },
      sizeX: 1,
      sizeY: 1,
      col: 0,
      row: 0,
      show: true
    },
    {
      search: true,
      show_list: true,
      as_title: false,
      status: false,
      fieldIndex: 1,
      title_order: 2,
      full_text: false,
      unique: true,
      min_value: '',
      max_value: '',
      field_id: '商材',
      name: '商材',
      display_id: '商材',
      dataType: 'text',
      component: 'InputArea',
      props: {
        labelName: '商材',
        labelText: '商材',
        name: '商材',
        isReadonly: true,
        isDisabled: true,
        rules: '',
        value: ''
      },
      sizeX: 1,
      sizeY: 1,
      col: 1,
      row: 0,
      show: true
    },
    {
      search: true,
      show_list: true,
      as_title: false,
      status: false,
      fieldIndex: 1,
      title_order: 2,
      full_text: false,
      unique: true,
      min_value: '',
      max_value: '',
      field_id: '商材仕入先',
      name: '商材仕入先',
      display_id: '商材仕入先',
      dataType: 'text',
      component: 'InputArea',
      props: {
        labelName: '商材仕入先',
        labelText: '商材仕入先',
        name: '商材仕入先',
        isReadonly: true,
        isDisabled: true,
        rules: '',
        value: ''
      },
      sizeX: 1,
      sizeY: 1,
      col: 3,
      row: 0,
      show: true
    }
  ];
}
export const materialTemplateRegisterHeader = headerForm.materialTemplateRegister;

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace masterForm {}
